type DqlEditorFeatureFlags = {
  // No flags yet
}

/** A type that represents all of our feature flags. These are managed
 *  in LaunchDarkly, and can be found at:
 *  https://app.launchdarkly.com/default/{environment}/features
 *
 *  NOTE: flags can come back as undefined, so we need to use Partial
 **/
export type FeatureFlags = Partial<DqlEditorFeatureFlags>

export { useFeatureFlags } from './useFeatureFlags'
